import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_permission",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"btn btn-icon btn-sm btn-active-icon-primary\" data-kt-permissions-modal-action=\"close\" data-bs-dismiss=\"modal\"><span class=\"svg-icon svg-icon-1\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect opacity=\"0.5\" x=\"6\" y=\"17.3137\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(-45 6 17.3137)\" fill=\"black\"></rect><rect x=\"7.41422\" y=\"6\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(45 7.41422 6)\" fill=\"black\"></rect></svg></span></div>", 1)
const _hoisted_7 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_8 = {
  id: "kt_modal_add_permission_form",
  class: "form",
  action: "#"
}
const _hoisted_9 = { class: "fv-row mb-7" }
const _hoisted_10 = { class: "fs-6 fw-bold form-label mb-2" }
const _hoisted_11 = { class: "required" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "popover",
  "data-bs-trigger": "hover",
  "data-bs-html": "true",
  "data-bs-content": "Permission names is required to be unique."
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-control form-control-solid",
  placeholder: "Enter a permission name",
  name: "permission_name"
}, null, -1)
const _hoisted_14 = { class: "text-center pt-15" }
const _hoisted_15 = {
  type: "reset",
  class: "btn btn-light me-3",
  "data-kt-permissions-modal-action": "cancel"
}
const _hoisted_16 = {
  type: "submit",
  class: "btn btn-primary",
  "data-kt-permissions-modal-action": "submit"
}
const _hoisted_17 = { class: "indicator-label" }
const _hoisted_18 = { class: "indicator-progress" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("permissionAdd")), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("permissionName")), 1),
                _hoisted_12
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.$t("discard")), 1),
              _createElementVNode("button", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("submit")), 1),
                _createElementVNode("span", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + "... ", 1),
                  _hoisted_19
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}